import { CommonModule } from '@angular/common';
import {
    Component,
    EventEmitter,
    Input,
    InputSignal,
    OnInit,
    Output,
    input,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { DatiqIconsModule } from '@dat/datiq-components-pkg/icons';
import { DatiqTemplateModule } from '@dat/datiq-components-pkg/template';

@Component({
    selector: 'iq-controls-reset-button',
    standalone: true,
    imports: [CommonModule, DatiqTemplateModule, MatIcon, DatiqIconsModule],
    templateUrl: './iq-controls-reset-button.component.html',
    styleUrl: './iq-controls-reset-button.component.scss',
})
export class IqControlsResetButtonComponent implements OnInit {
    id: InputSignal<string> = input('');
    label: InputSignal<string> = input('Reset');
    initialData: any = {};
    disabled: InputSignal<boolean> = input(false);

    @Input()
    fg: FormGroup = this._fb.group({});

    @Output()
    resetted = new EventEmitter<any>();

    constructor(private readonly _fb: FormBuilder) {}

    ngOnInit() {
        this.initialData = Object.freeze(this.fg.value);
    }

    reset() {
        this.fg.setValue(this.initialData);
        this.fg.updateValueAndValidity();
        this.resetted.emit(this.initialData);
    }
}
